import './index.scss';

import { Layout } from 'antd';
import { OrganizationSwitcher } from './OrganizationSwitcher';
import { SidebarArovyLogo } from './SidebarArovyLogo';
import { SidebarMenu } from './SidebarMenu';

import React, { useEffect } from 'react';
import { useApplicationSidebar, usePeriscopeCount } from '@hooks';

const { Sider } = Layout;

export const Sidebar: React.FC = () => {
	const { isClosed, toggle } = useApplicationSidebar();
	const periscopeCount = usePeriscopeCount();

	useEffect(() => {
		// This addresses various component resizing issues that may occur
		// when the sidepanel is collapsing immediately upon load.
		setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
	}, [ isClosed ]);

	const sliderStyleOptions = periscopeCount > 0 ? { transition: 'none' } : {};

	return (
		<Sider
			collapsed={ isClosed }
			collapsedWidth={ 80 }
			collapsible
			id='sidebar'
			onCollapse={ toggle }
			style={ sliderStyleOptions }
			width={ 310 }>
			<OrganizationSwitcher isClosed={ isClosed } />
			<SidebarArovyLogo isClosed={ isClosed } />
			<SidebarMenu />
		</Sider>
	);
};
